module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-right-49fc02d9.svg";